import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export function TeacherRouteGuard({ element }) {
  const location = useLocation();
  const teacherToken = useSelector((state) => state.teacher?.token);

  if (!teacherToken) {
    return (
      <Navigate
        to="/teacherlogin"
        replace
        state={{
          from: location,
          message: "Please log in to continue.",
        }}
      />
    );
  }

  return element;
}

export function TeacherPublicRoute({ element }) {
  const teacherToken = useSelector((state) => state.teacher?.token);

  if (teacherToken) {
    return <Navigate to="/teacherdashboard" replace />;
  }

  return element;
}
